module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 56.63 56.63"
    }
  }, [_c('title', [_vm._v("market_icon")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Layer_2",
      "data-name": "Layer 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Layer_3",
      "data-name": "Layer 3"
    }
  }, [_c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "28.31",
      "cy": "28.31",
      "r": "26.71",
      "fill": "#fff",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.22"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.43,20.77C16.19,9.69,21.74,1.61,28.31,1.61c3.51,0,6.73,2.3,9.23,6.13",
      "fill": "#fff",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.22"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.38,22a47.4,47.4,0,0,1,.41,6.27C42.79,43.06,36.31,55,28.31,55c-6.57,0-12.12-8.09-13.88-19.17",
      "fill": "#fff",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.22"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35.18,40.22a27,27,0,0,1,13,6",
      "fill": "#fff",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.22"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.49,46.21a26.84,26.84,0,0,1,13-6",
      "fill": "#fff",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.22"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M46.62,11.66a19,19,0,0,0,1.52-1.24",
      "fill": "#fff",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.22"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.49,10.42c4.45,4,11.67,6.63,19.82,6.63A37.07,37.07,0,0,0,34,16.62",
      "fill": "#fff",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.22"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20.64",
      "y1": "28.31",
      "x2": "55.02",
      "y2": "28.31",
      "fill": "#fff",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.22"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "1.61",
      "y1": "28.31",
      "x2": "7.3",
      "y2": "28.31",
      "fill": "#fff",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.22"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "28.31",
      "y1": "32.31",
      "x2": "28.31",
      "y2": "1.61",
      "fill": "#fff",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.22"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "28.31",
      "y1": "55.02",
      "x2": "28.31",
      "y2": "46.78",
      "fill": "#fff",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.22"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40.8",
      "cy": "14.81",
      "r": "4.62",
      "fill": "#fff",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.22"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "13.84",
      "cy": "28.31",
      "r": "4.62",
      "fill": "#fff",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.22"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.94,39.58A4.63,4.63,0,1,1,28.31,35,4.62,4.62,0,0,1,32.94,39.58Z",
      "fill": "#fff",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.22"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e90571e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/icons/MarketIcon.vue
// module id = 3326
// module chunks = 0